import { Injectable, signal } from '@angular/core';

export const DEFAULT_DOCS_URL = 'https://docs.trace0hq.com';

@Injectable({ providedIn: 'root' })
export class DocsLinkService {
  private _url = signal(DEFAULT_DOCS_URL);
  url = this._url.asReadonly();

  set(url: string): void {
    this._url.set(url);
  }

  reset(): void {
    this._url.set(DEFAULT_DOCS_URL);
  }
}
